import React from "react";
import { createRoot } from "react-dom/client";
import { HashRouter, Routes, Route } from "react-router-dom";

import App from "./components/App";
import AdminPage from "./components/Admin";

import "./reset.css";
import "./styles.css";
import "./index.css";

const root = createRoot(document.querySelector("#root"));
root.render(
    <HashRouter>
        <Routes>
            <Route path="/" element={<App />} />
            <Route path="/occ-admin" element={<AdminPage />} />
        </Routes>
    </HashRouter>
);
